import ArtileEl, {
  White,
  Desc,
  Header,
  CustomImage,
  Quote,
  Author,
  QuoteEl,
} from "../../components/Elements/ArticleEl";
import { ArticleElBackgroundWrapper } from "../../components/Elements/ArticleElBackgroundWrapper";

import VideoElement from "../../components/Elements/VideoElement";
import ImageSlider from "../../components/Elements/ImageSlider";
import QuoteSliderSlick from "../../components/Elements/QuoteSliderSlick";
import BtnParallax from "../../components/Elements/BtnParallax";

import { isMobile } from "../../hooks/isMobile";

import cases from "../cases/cases.json";
import HomeVideoSlider from "../../components/Elements/HomeVideoSlider";

const componentName = "AldiGoodGame";

const shorthand = cases.find((x) => x.component == componentName).shorthand;

if (typeof shorthand == "undefined")
  console.error("Component can't find shorthand: " + componentName);

export default (handleVideoModalOpen) => (
  <>
    <ArticleElBackgroundWrapper id={shorthand} variant={"article_top"}>
      <ArtileEl
        type={"text-right-half"}
        size={"xl"}
        center
        style={{
          paddingTop: 0,
          paddingBottom: 0,
          margin: 0,
        }}
      >
        <Header customType="header">
          <div className="section-hero">
            <div className="section-title-sub grad-txt">
              Das Good Game Für Alle
            </div>
          </div>
        </Header>

        <Desc customType="desc">
          <White>A custom-built Fortnite Speed Run Island </White> created as
          the grand finale of ALDI Gaming’s year-long Twitch campaign{" "}
          <White>- that increased stream viewership by over 200%.</White>
        </Desc>

        <CustomImage
          maxWidth={isMobile ? "100%" : "25%"}
          customType="image"
          round
          flex
          backgroundSize={"cover"}
          backgroundPosition={"center"}
          ar={isMobile ? 16 / 9 : 1}
          outline={isMobile ? false : true}
          src={
            isMobile
              ? `/img/cases/${shorthand}/image/img_02.jpg`
              : `/img/cases/${shorthand}/image/img_01.jpg`
          }
        />
      </ArtileEl>
    </ArticleElBackgroundWrapper>

    <QuoteSliderSlick>
      <QuoteEl size="s" no-p-quote no-p fullfill>
        <Quote customType="quote">
          "This is so cool - who built this?! I can’t wait to see how the
          community speedruns it!"
        </Quote>
        <Author customType="author">
          <White>- NoWay</White>
        </Author>
      </QuoteEl>

      <QuoteEl size="s" no-p-quote no-p fullfill>
        <Quote customType="quote">
          "This is insanely fun! It’s crazy what you can build in Fortnite.
          What’s possible with the engine for creating games and entire levels
          is just wild."
        </Quote>
        <Author customType="author">
          <White>- Mahluna</White>
        </Author>
      </QuoteEl>

      <QuoteEl size="s" no-p-quote no-p fullfill>
        <Quote customType="quote">
          "We designed the island to thrive on stream. Easy to follow, quick to replay, and fun every time."
        </Quote>
        <Author customType="author">
          <White>
            - Christine Niemann, <i>Co-Founder Stunning Studio</i>
          </White>
        </Author>
      </QuoteEl>
    </QuoteSliderSlick>

    <div className="section-div">
      <div
        className="section-img"
        style={{ pointerEvents: "all", width: "100%", marginTop: 0 }}
      >
        <VideoElement
          aspectratio={isMobile ? 3 / 4 : 2.35 / 1}
          round
          shorthand={"aldi-preview"}
        />
        <div className="section-vid-overlay-play">
          <div
            className="vid-overlay-flex-center"
            style={{ paddingBottom: "20px" }}
          >
            <BtnParallax
              landing
              filled
              text={"Watch Trailer"}
              filmicon
              addclass={"btn-parallax-sol-pseudo"}
              small
              onclick={() => {
                handleVideoModalOpen(true, false);
              }}
            />
          </div>
        </div>
      </div>
    </div>

    <div className="section-div">
      <div
        className="section-content bigger left"
        style={{ flexDirection: "column" }}
      >
        <div className="section-hero">
          <div className="section-title-sub grad-txt">The Idea</div>
        </div>

        <div className="section-description">
          “Das Good Game Für Alle” marked the{" "}
          <White>grand finale of a year-long ALDI Gaming Twitch campaign</White>
          , packed with games and challenges <White>for streamers and the community.</White>
          <br />
          <br />
          To top off the campaign with maximum energy, we built a{" "}
          <White>custom Fortnite Speed Run Island</White> - fast to pick up,
          hard to master, and designed for live competition.
          <br />
          <br />
          The island <White>features playful nods to gaming culture</White> and a course layout
          that <White>encourages constant retries, leaderboard-style racing, and
          creator-vs-community showdowns.</White>
        </div>
      </div>
    </div>

    <ArticleElBackgroundWrapper
      id={"slider" + shorthand}
      variant={"article_slider"}
    >
      <div className="section-div no-p">
        <ImageSlider
          data={[
            `/img/cases/${shorthand}/image/slider_NOWAY.jpg`,
            `/img/cases/${shorthand}/image/slider_MAHLUNA.jpg`,
            `/img/cases/${shorthand}/image/slider_LOSTKITTN.jpg`,
            `/img/cases/${shorthand}/image/slider_ZEUSSPECIAL.jpg`,
            `/img/cases/${shorthand}/image/slider_NIKA_NANIKA.jpg`,
          ]}
        />
      </div>
    </ArticleElBackgroundWrapper>

    <div className="section-div">
      <div
        className="section-content bigger left"
        style={{ flexDirection: "column" }}
      >
        <div className="section-hero">
          <div className="section-title-sub grad-txt">
            4 Custom Game-Themed Levels Inspired by Iconic Classics
          </div>
        </div>

        <div className="section-description">
          <White>
            From block-stacking chaos to high-speed racing and sandbox-inspired
            challenges
          </White>{" "}
          each custom-built level reimagined beloved gaming classics inside a
          fast-paced Fortnite Island, blending nostalgia with modern
          competition.
        </div>
      </div>
    </div>

    <div className="section-div">
      <div
        className="section-content bigger left"
        style={{ flexDirection: "column" }}
      >
        <HomeVideoSlider
          shouldRestart={true}
          addFiller={true}
          preload="metadata"
          data={[
            [
              <div
                className={"clickable"}
                style={{
                  height: "55px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span style={{ transform: "rotate(180deg)" }}>💨</span>🏃‍♂️‍➡️
                START
              </div>,
              "aldi-gameplay-start",
            ],
            [
              <div
                className={"clickable"}
                style={{
                  marginLeft: "0.125ch",
                  height: "55px",
                  width: "7.2ch",
                  cursor: "pointer",
                  background: `url("/img/cases/${shorthand}/image/Level1.png")`,
                  backgroundSize: "contain",
                  backgroundPosition: "0% 50%",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>,
              "aldi-gameplay-level1-stacking-blocks",
            ],
            [
              <div
                className={"clickable"}
                style={{
                  height: "55px",
                  width: "9.5ch",
                  background: `url("/img/cases/${shorthand}/image/Level2.png")`,
                  backgroundSize: "contain",
                  backgroundPosition: "0% 50%",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>,
              "aldi-gameplay-level2-voxelworld",
            ],
            [
              <div
                className={"clickable"}
                style={{
                  marginLeft: "0.125ch",
                  height: "55px",
                  width: "8ch",
                  background: `url("/img/cases/${shorthand}/image/Level3.png")`,
                  backgroundSize: "contain",
                  backgroundPosition: "0% 50%",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>,
              "aldi-gameplay-level3-teleporter-puzzle",
            ],
            [
              <div
                className={"clickable"}
                style={{
                  marginLeft: "0.125ch",
                  height: "55px",
                  width: "10ch",
                  background: `url("/img/cases/${shorthand}/image/Level4.png")`,
                  backgroundSize: "contain",
                  backgroundPosition: "0% 50%",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>,
              "aldi-gameplay-level4-shopping-cart",
            ],
            [
              <div
                className={"clickable"}
                style={{
                  marginLeft: "0.125ch",
                  height: "55px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                🏁 FINISH 🏁
              </div>,
              "aldi-gameplay-finish",
            ],
          ]}
        />
      </div>
    </div>

    <ArtileEl type={"text-left-half"} small-header small-desc>
      <Header customType="header">High-Quality Product Integration</Header>
      <Desc customType="desc">
        ALDI products became part of the gameplay itself seamlessly integrated as{" "}
        <White>interactive power-ups and dynamic level elements</White>.
      </Desc>

      <VideoElement
        customType="video"
        round
        aspectratio={16 / 9}
        shrink
        shorthand={"aldi-product-integration"}
      />
    </ArtileEl>

    <ArtileEl type={"text-right-half"} small-header small-desc>
      <Header customType="header">Streamable and Replayable</Header>
      <Desc customType="desc">
        A high-energy playground built for Twitch: short rounds, quick resets,
        and constant momentum.
        <br />
        <br />
        <White>
          Creators like NoWay, Mahluna, LostKittn, ZeusSpezial, Nika_Nanika and
          Stegi
        </White>{" "}
        - battling for the fastest times, competing for prizes, and turning the
        finale stream into a real-time showdown.{" "}
      </Desc>

      <VideoElement
        customType="video"
        round
        shrink
        shorthand={"aldi-streamer"}
      />
    </ArtileEl>

    <ArtileEl type={"text-left-half"} small-header small-desc>
      <Header customType="header">The Community Challenge</Header>
      <Desc customType="desc">
        <White>Two weeks. One leaderboard. Only the Top 3 win.</White> Players
        had a limited time to master every shortcut, perfect every jump, and
        secure their place at the top of the rankings.
      </Desc>

      <CustomImage
        maxWidth={"100%"}
        customType="image"
        round
        flex
        backgroundSize={"cover"}
        backgroundPosition={"center"}
        ar={16 / 9}
        outline={true}
        src={`/img/cases/${shorthand}/image/community-challenge.jpg`}
      />
    </ArtileEl>

    <div className="section-div">
      <div
        className="section-content bigger left"
        style={{ flexDirection: "column" }}
      >
        <div className="section-hero">
          <div className="section-title-sub grad-txt">Results</div>
        </div>

        <div className="section-description">
          The finale delivered a competitive, community-driven moment that
          capped off the campaign in style. The Speed Run format encouraged
          retries, rivalries, and live reactions - and helped boost the ALDI
          Gaming stream to <White>more than 200%</White>.
        </div>
      </div>

      <div className="section-img" style={{ width: "100%" }}>
        <VideoElement
          aspectratio={isMobile ? 16 / 9 : 2.35 / 1}
          round
          shorthand={"aldi-results"}
        />
      </div>
    </div>

    <div className="section-div">
      <div className="section-content bigger left credits">
        <div className="credit-headline">
          <div className="section-title-sub">Credits</div>
          <div className="credit-divider"></div>
        </div>

        <div className="credits">
          <div className="credits-column">
            <div className="credit-block">
              <div className="credits-title">Client</div>
              <div className="credits-name">ALDI Nord &amp; ALDI SÜD</div>
            </div>
          </div>

          <div className="credits-column">
            <div className="credit-block">
              <div className="credits-title">Agency</div>
              <div className="credits-name">
                Strafejump &amp; Accenture Song
              </div>
            </div>
          </div>

          <div className="credits-column">
            <div className="credit-block">
              <div className="credits-title">Production Company</div>
              <div className="credits-name">Stunning Studio</div>
            </div>
          </div>

          <div className="credits-column">
            <div className="credit-block">
              <div className="credits-title">Creators</div>
              <div className="credits-name">
                NoWay, Mahluna, LostKittn, ZeusSpezial, Nika_Nanika, stegi
              </div>
            </div>
          </div>
        </div>

        <div className="credit-headline"></div>
      </div>
    </div>
  </>
);
